export default __webpack_public_path__ + "static/media/icon-check.e9e562d9.svg";